var _a;
import React from 'react';
import { BetaBadge } from './beta-badge/beta-badge';
export var Badges;
(function (Badges) {
  Badges[Badges["BETA"] = 1] = "BETA";
})(Badges || (Badges = {}));
export var badgeItem = (_a = {}, _a[Badges.BETA] = React.createElement(BetaBadge, null), _a);